import Component from '@glimmer/component';

export default class PageHeadersFilterActionsComponent extends Component {
  get filterActionSelector() {
    return document.querySelector('#filter-action');
  }
}
